import React from 'react';
import Icon from '../assets/icons';
import DoteDivider from '../common/DoteDivider';
import { CaseLinksContainer, Description, IconWrapper, Item } from './styles';
import { formatDateRange, formatTimeToHoursMinutes } from './utils';

type TTimeChain = {
  startDate: string;
  endDate: string;
  time: string;
  lang?: string;
};

const TimeChain = ({ startDate, endDate, time, lang = 'ru' }: TTimeChain) => (
  <CaseLinksContainer>
    {startDate && endDate && (
      <>
        <Item>
          <IconWrapper>
            <Icon variant='calendar' />
          </IconWrapper>
          <Description>{formatDateRange(startDate, endDate)}</Description>
        </Item>
        <DoteDivider />
      </>
    )}
    {time && (
      <>
        <Item>
          <IconWrapper>
            <Icon variant='sandClock' />
          </IconWrapper>
          <Description>{formatTimeToHoursMinutes(time, lang)}</Description>
        </Item>
        <DoteDivider />
      </>
    )}
    <Item>
      <IconWrapper>
        <Icon variant='watch' />
      </IconWrapper>
      <Description>UTC</Description>
    </Item>
  </CaseLinksContainer>
);

export default TimeChain;
